

/** @name 预览表单项协议【使用PreviewItemTemplate.vue组件的根组件需要实现该协议】
 *  @author 王汝鹏
 *  @version 2019-11-29
 */
export const mixPreviewItemTemplateProtocol = {
  provide() {
    return {
      preview_item_template_store: this.preview_item_template_store,
      preview_item_template_node_action_manager: this.preview_item_template_node_action_manager,
    }
  },
  computed: {
    /** 协议数据声明 [空实现，需要在使用的地方重写方法] ::: 
     *  @return {Object} eventMap 事件字典
     *  @return {Object} formMap 表单项字典
     *  @return {Object} formModels 表单填写变量
     *  @return {Boolean} itemPickControl 表单项勾选控制开关
     *  @return {Object} variableMap 变量配置字典
     */
    preview_item_template_store: {
      get() { 
        return {
          eventMap: {},
          formMap: {},
          formModels: {},
          itemPickControl: false,
          variableMap: {},
          toggleClearModelState: true
        }; 
      }
    },
    /** 协议方法声明 [空实现，需要在使用的地方重写方法] :::
     *  @function preview_item_template_node_action_manager 节点行为管理者
     */
    preview_item_template_node_action_manager: { get() { return new Function('node', 'return {};'); } }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/preview_item/mix_preview_item_template_protocol.js